import React, { useState, useEffect } from 'react';
import { Button, LoadingIcon, MenuPopup } from '@prosolve/common-components-ui'
import useFetch from '../../hooks/useFetch';
import styled from 'styled-components';
import { FaArrowRight, FaEllipsisV, FaFolder } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import Tabs from '../../sharedComponents/Tabs';
import { Accordion } from '@prosolve/common-components-ui'
import ManageFoldersModal from './ManageFoldersModal';
import RenameExistingFoldersModal from './RenameExistingFoldersModal';

const Table = styled.table`
  background: #ffffff;
  border: 1px solid #c4c4c4;
  border-radius: 5px;
  color: #080808;
  font-size: 14px;
  border-spacing: 0;
`;

const TableBody = styled.tbody``;

const TableRow = styled.tr`
  cursor: pointer;
  &:last-child td {
    border-bottom: none;
  }
`;

const TableColumn = styled.td`
  padding: 8px 20px;
  border-bottom: 1px solid #c4c4c4;
`;

export default () => {
  const fetch = useFetch();
  const navigate = useNavigate();

  const adminPermissionsCookies = Cookies.get('adminPermissions') || '';
  const isReadOnly = !(adminPermissionsCookies.indexOf('ASSESSMENT_BUILDER_EDIT') > -1);

  const [isLoading, setIsLoading] = useState(true)
  const [assessmentNames, setAssessmentNames] = useState([]);
  const [addToFolderOpen, setAddToFolderOpen] = useState()
  const [renameFolderOpen, setRenameFolderOpen] = useState()

  const tabs = ['Enabled', 'Disabled']
  
  const [selectedTab, setSelectedTab] = useState('Enabled')

  const enabledAssessmentNamesByFolder = {}
  const disabledAssessmentNamesByFolder = {}
  const enabledAssessmentNames = []
  const disabledAssessmentNames = []

  assessmentNames.forEach(assessmentName => {
    const { disabled, folder = '' } = assessmentName;
    let folderMap
    if (disabled) {
      disabledAssessmentNames.push(assessmentName)
      folderMap = disabledAssessmentNamesByFolder
    } else {
      enabledAssessmentNames.push(assessmentName)
      folderMap = enabledAssessmentNamesByFolder
    }

    if (!folderMap[folder]) {
      folderMap[folder] = []
    }
    folderMap[folder].push(assessmentName)
  });

  const sortFolders = (items, ascending = true) => {
    return [...items].sort((a, b) => {
      // always keep empty string at the end
      if (a === '' && b === '') return 0;
      if (a === '') return 1;
      if (b === '') return -1;
      // normal sort for everything else
      return ascending
        ? a.localeCompare(b)
        : b.localeCompare(a);
    });
  }

  const fetchAssessmentNames = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`assessment/builder/list`, { method: 'GET' })
      const jsonData = await response.json();
      if (jsonData.error) {
        setAssessmentNames([])
      } else {
        setAssessmentNames(jsonData)
      }
      setIsLoading(false);
    } catch (e) {
      console.log(e)
      setAssessmentNames([])
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchAssessmentNames()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const addEditAssessment = async (assessmentName) => {
    navigate(`${assessmentName}`);
  }

  const [isFolderActionMenuOpen, setIsFolderActionMenuOpen] = useState()

  const [isActionMenuOpen, setIsActionMenuOpen] = useState()

  const [foldersDefaultOpen, setFoldersDefaultOpen] = useState(false)

  const onCloneAssessment = (data) => {
    if (!isReadOnly && data) {
      const clonedData = { ...data, name: `Cloned-${data.name || ''}` }
      delete clonedData.active
      delete clonedData.disabled
      delete clonedData.isDraft
      navigate('new', {
        state: { clonedData }
      });
    }
  }

  const onAddToFolder = (data) => {
    if (!isReadOnly && data) {
      setAddToFolderOpen(data)
    }
  }

  const menuActions = [
    {
      label: 'Clone Assessment',
      action: onCloneAssessment
    },
    {
      label: 'Add to Folder',
      action: onAddToFolder
    }
  ]

  const actionMap = Object.fromEntries(menuActions.map(({ label, action }) => [label, action]))

  const onActionSelection = (val, data) => {
    actionMap[val]?.(data)
    setIsActionMenuOpen(undefined)
  }

  const displayedAssessmentNameMaps = selectedTab === 'Disabled' ? disabledAssessmentNamesByFolder : enabledAssessmentNamesByFolder
  
  const getAssessmentTable = (displayedAssessmentNames) => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Table>
          <TableBody>
            {
              displayedAssessmentNames
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((assessment) => {
                  const { _id, name = '' } = assessment
                  return (
                    <TableRow key={name} onClick={() => addEditAssessment(name)}>
                      <TableColumn>
                        {name}
                      </TableColumn>
                      <TableColumn style={{ textAlign: 'right' }}>
                        <FaArrowRight style={{ fontSize: '22px', color: '#0280c6' }} />
                        {
                          !isReadOnly &&
                          <div style={{ position: 'relative', display: 'inline-block', top: '-2px' }}>
                            <FaEllipsisV
                              style={{ marginLeft: '20px', fontSize: '18px', color: '#565656' }}
                              onClick={(e) => {
                                e.stopPropagation()
                                if (isActionMenuOpen === _id) {
                                  setIsActionMenuOpen(undefined)
                                } else {
                                  setIsActionMenuOpen(_id)
                                }

                              }}
                            />
                            <MenuPopup
                              open={isActionMenuOpen === _id}
                              top='25px'
                              left='-190px'
                              width='240px'
                              options={menuActions.map(({ label }) => label)}
                              onClose={() => setIsActionMenuOpen(undefined)}
                              onSelection={(val) => onActionSelection(val, assessment)}
                            />
                          </div>
                        }
                      </TableColumn>
                    </TableRow>
                  )
                })
            }
          </TableBody>
        </Table>
      </div>
    )
  }

  return (
    isLoading ?
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <LoadingIcon />
    </div>
    :

    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      padding: '0px'
    }}>

      <div style={{ marginTop: '10px', position: 'relative' }}>
        <Tabs tabs={tabs} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
        <div style={{ 
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          bottom: '5px',
          right: '5px',
          color: '#0280c6',
          fontSize: '12px',
        }}>
          <div style={{ fontSize: '11px' }}>{'Folders:'}</div>
          <div 
            style={{
              textDecoration: 'underline',
              fontStyle: 'italic',
              cursor: 'pointer'
            }}
            onClick={() => { 
              setFoldersDefaultOpen(true)
              // hack which refetches to referender since accordians currently dont support ref method to toggle
              fetchAssessmentNames()
            }}
          >
            {'Expand All'}
          </div>
          <div style={{ fontSize: '11px' }}>{'|'}</div>
          <div 
            style={{
              textDecoration: 'underline',
              fontStyle: 'italic',
              cursor: 'pointer'
            }}
            onClick={() => { 
              setFoldersDefaultOpen(false)
              // hack which refetches to referender since accordians currently dont support ref method to toggle
              fetchAssessmentNames()
            }}
          >
            {'Collapse All'}
          </div>
        </div>
      </div>

    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      padding: '20px',
      gap: '10px'
    }}>
      {
        Boolean(addToFolderOpen) &&
        <ManageFoldersModal
          assessment={addToFolderOpen}
          allAssessments={assessmentNames}
          onClose={() => setAddToFolderOpen(undefined)}
          reloadData={fetchAssessmentNames}
          onConfirmation={() => setAddToFolderOpen(undefined)}
        />
      }
      {
        Boolean(renameFolderOpen) &&
        <RenameExistingFoldersModal
          currentFolderName={renameFolderOpen}
          assessments={displayedAssessmentNameMaps[renameFolderOpen]}
          onClose={() => setRenameFolderOpen(undefined)}
          reloadData={fetchAssessmentNames}
          onConfirmation={() => setRenameFolderOpen(undefined)}
        />
      }
      {
        sortFolders(Object.keys(displayedAssessmentNameMaps)).map(folder => {
          const displayedAssessmentNames = displayedAssessmentNameMaps[folder]
          return (
            <React.Fragment key={folder ? `accordian-folder-${folder}` : 'empty-folders'}>
              {
                folder ? (
                  <Accordion
                    title={
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FaFolder style={{ color: '#0280c6' }} />
                        <div style={{ color: '#565656', fontWeight: 'bold' }}>{folder}</div>
                        {
                          !isReadOnly &&
                          <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end', marginRight: '10px' }}>
                            <div style={{ position: 'relative', display: 'inline-block', top: '1px' }}>
                              <FaEllipsisV
                                style={{ marginLeft: '5px', fontSize: '12px', /*color: '#565656',*/ color: '#8b8d94' }}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  if (isFolderActionMenuOpen === folder) {
                                    setIsFolderActionMenuOpen(undefined)
                                  } else {
                                    setIsFolderActionMenuOpen(folder)
                                  }

                                }}
                              />
                              <MenuPopup
                                open={isFolderActionMenuOpen === folder}
                                top='15px'
                                // left='-25px'
                                left='-120px'
                                width='140px'
                                // width='240px'
                                options={['Rename Folder']}
                                onClose={() => setIsFolderActionMenuOpen(undefined)}
                                onSelection={(val) => val === 'Rename Folder' && setRenameFolderOpen(folder)}
                              />
                            </div>
                          </div>
                        }
                      </div>
                    }
                    headerExpands={true}
                    defaultOpen={foldersDefaultOpen}
                    style={{
                      padding: '10px 10px 10px 0px'
                    }}
                    expandedStyle={{
                      padding: '0px 0px 10px 0px'
                    }}
                  >
                    {getAssessmentTable(displayedAssessmentNames)}
                  </Accordion>
                ) :
                  getAssessmentTable(displayedAssessmentNames)
              }
            </React.Fragment>
          )
        })
      }
      {
        selectedTab !== 'Disabled' &&
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '40px', paddingBottom: '20px' }}>
          <Button
            style={{ width: '250px' }}
            $colored={true}
            $disabled={isReadOnly}
            onClick={() => {
              if (!isReadOnly) {
                addEditAssessment('new')
              }
            }}
          >
            {'Create New Assessment'}
          </Button>
        </div>
      }
    </div>
    </div>
  )
}